import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { AdaptedMediaGateway } from 'data/mediaGateway/mediaGateway.types';

export enum MediaGatewayMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newMediaGateway: AdaptedMediaGateway = {
  mgwtype: 'AudioCodes',
  id: 0,
  ipaddr: '',
  port: 0,
  name: '',
  reqstate: 'ACTIVE',
  version: '',
  ownnetid: '',
  enablejitter: 'NO',
  mgwuri: '',
  insidenat: '',
  mediagatewaynumlist: [],
};

export const mediaGatewayColumnDefs: ColDef[] = [

    {
      headerName: i18n.t('mediaGateway.form.field.id'),
      field: 'id',
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      resizable: true,
      tooltipField: 'id',
      flex: 1,
    minWidth: 165,
    },
    {
      headerName: i18n.t('mediaGateway.grid.mgwtype'),
      field: 'mgwtype',
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      resizable: true,
      tooltipField: 'mgwtype',
      flex: 1,
      minWidth: 165,
    },
    {
      headerName: i18n.t('mediaGateway.grid.ipaddr'),
      field: 'ipaddr',
      sortable: true,
      resizable: true,
      tooltipField: 'ipaddr',
      flex: 1,
      minWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('mediaGateway.grid.port'),
      field: 'port',
      sortable: true,
      resizable: true,
      tooltipField: 'port',
      flex: 1,
      minWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('mediaGateway.grid.name'),
      field: 'name',
      sortable: true,
      resizable: true,
      tooltipField: 'name',
      flex: 1,
      minWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('mediaGateway.grid.version'),
      field: 'version',
      sortable: true,
      resizable: true,
      tooltipField: 'version',
      flex: 1,
      minWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('mediaGateway.grid.ownnetid'),
      field: 'ownnetid',
      sortable: true,
      resizable: true,
      tooltipField: 'ownnetid',
      flex: 1,
      minWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
];
